const FormActionButtons = ({
  onCancel,
  submitLabel = 'Simpan',
  cancelLabel = 'Batal',
  showCancel = true,
  fullWidth = false,
}) => {
  return (
    <div className={`mt-6 ${fullWidth ? 'flex space-x-4' : 'flex space-x-4 justify-end'}`}>
      {showCancel && (
        <button
          type="button"
          onClick={onCancel}
          className={`py-2.5 text-sm font-medium bg-gray-400 text-white rounded-md hover:bg-gray-500 transition ${fullWidth ? 'flex-1' : 'px-6'}`}
        >
          {cancelLabel}
        </button>
      )}
      <button
        type="submit" // ✅ tetap gunakan ini
        className={`py-2.5 text-sm font-medium bg-green-600 text-white rounded-md hover:bg-green-700 transition ${fullWidth ? 'flex-1' : 'px-6'}`}
      >
        {submitLabel}
      </button>
    </div>
  );
};
export default FormActionButtons;

